import {
  Image,
  withStory,
  WithStoryProps,
} from '@storyofams/storyblok-toolkit';
import { GetStaticProps } from 'next';
import SbEditable from 'storyblok-react';

import { Container, Heading, Seo } from '~/components';
import { BannerDynamic } from '~/components/Banners/BannerDynamic';
import { ContactForm } from '~/components/Blocks/ContactForm';
import { enhancedStaticProps } from '~/lib';
import { withLayout } from '~/lib/withLayout';

export interface ContactProps extends WithStoryProps {}

const Contact = ({ story }: ContactProps) => {
  const content = story?.content;

  return (
    <>
      <Seo story={story} />

      <SbEditable content={content}>
        <div className="bg-yellow-100">
          <Container first>
            <Heading as="h1" variant="h1" className="max-w-lg mb-4">
              {content?.title}
            </Heading>
            <p className="max-w-lg text-grey-700">{content?.description}</p>
            <div className="flex space-y-10 md:space-y-0 md:space-x-10 xl:space-x-32 mt-10 flex-col md:flex-row">
              <div className="w-full flex-1 max-h-80 md:max-h-full rounded-2xl overflow-hidden relative image--rounded">
                <Image
                  alt={content?.image?.alt || ''}
                  src={content?.image?.filename}
                  fluid={800}
                  fit="cover"
                  showPlaceholder={false}
                  height="100%"
                />
              </div>
              <ContactForm className="pl-0 pr-0 pb-0 lg:pb-0 flex-1" />
            </div>
          </Container>
        </div>
        {story?.content?.banner?.content && (
          <SbEditable content={story.content.banner.content}>
            <Container className="pb-0 lg:pb-0">
              <BannerDynamic content={story?.content?.banner?.content} />
            </Container>
          </SbEditable>
        )}
      </SbEditable>
    </>
  );
};

export default withLayout(withStory(Contact));

export const getStaticProps: GetStaticProps = enhancedStaticProps(
  async ({ sdk }) => {
    let story;
    let notFound = false;

    try {
      story = (await sdk.contactItem({ slug: 'contact' })).ContactItem;
    } catch (e) {
      notFound = true;
    }

    return {
      props: {
        story,
      },
      notFound: notFound || !story,
      revalidate: 60,
    };
  },
);
